import React from 'react';

import { GeneralConstants } from '../constants/general-constants';

interface IfProps {
    condition: boolean;
    children: React.ReactNode;
}

export class If extends React.Component<IfProps> {
    public render(): React.ReactNode {
        if (!this.props.condition) {
            return GeneralConstants.RENDER_NOTHING;
        }

        return this.props.children;
    }
}
